import { useSelector } from 'react-redux';

import HoldCancelClubMembership from 'profile/clubMembership/holdCancel/HoldCancelClubMembership';
import OnHoldMessage from 'profile/clubMembership/holdCancel/OnHoldMessage';
import UpcomingCancelMessage from 'profile/clubMembership/holdCancel/UpcomingCancelMessage';
import UpcomingHoldMessage from 'profile/clubMembership/holdCancel/UpcomingHoldMessage';

import PaymentDetails from '../../components/PaymentDetails';
import ShipTo from '../../components/ShipTo';
import { isUpcomingHold, isUpcomingCancel } from '../../helpers';

import FrequencyDetails from './subscription/FrequencyDetails';
import NextShipDate from './subscription/NextShipDate';

const ActiveMembership = (props) => {
  const { clubMembership } = props;
  const settings = useSelector((state) => state.setting);
  return (
    <div className="c7-account__club-status">
      {clubMembership.status === 'On Hold' && (
        <div>
          <h3>
            {clubMembership.club.title} <em>(On Hold)</em>
          </h3>
          <OnHoldMessage clubMembership={clubMembership} settings={settings} />
          <br />
        </div>
      )}
      {clubMembership.status !== 'On Hold' && (
        <div>
          <h3>
            {clubMembership.club.title} {renderUpcomingHold(clubMembership)}
          </h3>
          <NextShipDate clubMembership={clubMembership} />
          <br />
          <UpcomingCancelMessage
            clubMembership={clubMembership}
            settings={settings}
          />
          <UpcomingHoldMessage
            clubMembership={clubMembership}
            settings={settings}
          />
          <br />
        </div>
      )}

      <div className="c7-account-row">
        <div>
          <strong>Status</strong>
          <br />
          {clubMembership.status}
        </div>
        <div>
          <FrequencyDetails clubMembership={clubMembership} />
        </div>
      </div>

      <div className="c7-account-row">
        <div>
          <ShipTo clubMembership={clubMembership} />
          <br />
          <HoldCancelClubMembership clubMembership={clubMembership} />
        </div>

        <div>
          <PaymentDetails clubMembership={clubMembership} />
        </div>
      </div>
    </div>
  );
};

const renderUpcomingHold = (clubMembership) => {
  if (isUpcomingCancel(clubMembership)) {
    return (
      <>
        <em>(Upcoming Cancellation)</em>
      </>
    );
  }
  if (isUpcomingHold(clubMembership)) {
    return (
      <>
        <em>(Upcoming Hold)</em>
      </>
    );
  }
  return null;
};

export default ActiveMembership;
